module.exports = __webpack_public_path__ + "media/images/menu/channel_3_on-5ca4cf0e9be8e9263f7d2f13cb74b4b8.jpg";